import * as React from 'react';
import { Card, CardBody } from './Card';
import { Stack } from './Layout';

export interface DetailCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Bands edge to edge with a rule between each, for a record drawn as
   * header, notice, tabs and body (an impound). Each band pads itself.
   * Without it the card pads its contents and spaces them 24 apart.
   */
  bands?: boolean;
}

/**
 * The record picked from a list, opened beside it: a call, an invoice, a
 * lot, a truck, an impound, an inspection.
 *
 *   <ListDetailLayout list={…} detail={
 *     <DetailCard>
 *       <header>…title, badges, actions…</header>
 *       …sections…
 *     </DetailCard>
 *   } />
 *
 * One component because each panel used to wrap itself, and they drifted:
 * some in a Card, some in none, and the lot's in a Card without a CardBody,
 * which left it flush against its own border.
 */
export const DetailCard = React.forwardRef<HTMLDivElement, DetailCardProps>(
  function DetailCard({ bands = false, children, ...props }, ref) {
    return (
      <Card ref={ref} padding={bands ? 'none' : 'md'} radius="lg" {...props}>
        {bands ? (
          <Stack gap={0} divided>
            {children}
          </Stack>
        ) : (
          <CardBody>
            <Stack gap={6}>{children}</Stack>
          </CardBody>
        )}
      </Card>
    );
  }
);
